import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { errorToast, getInstanceId, successToast } from "../../Utils/utils";


export function loadContract(){

    // to submit a contract
    $("#dsvv_ok").on("click", function () {
        const check = $("#nschule-dsvv").is(":checked");
        if (check) {

            const slug = $("#slug").val()
            const url = '/contract/' + slug + '/sign'

            const success = function (data){
                successToast("Der Prozess wurde erfolgreich im System verarbeitet. Sie können sich jetzt anmelden.", "Erfolg", 30000, false);
                
                const link = $("#return-url").val();
                $("#dsvv_ok").replaceWith('<a class="btn btn-light-info" href="' + link +'">Zurück</a>')
            }

            ajaxRequest(url, success, {}, $(this));

        } else {
            errorToast("Sie müssen erst unten den Haken setzen", "Achtung", 0);
        }
    });
}